import { isSubdomainStoreMode } from '../utils/storeUtils';

let deferredInstallPrompt = null;
const installPromptListeners = new Set();

const notifyInstallPromptListeners = () => {
  installPromptListeners.forEach((listener) => listener());
};

const dismissStorageKey = (storeId) => `salovare.a2hs.dismissed.${storeId}`;

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
    notifyInstallPromptListeners();
  });

  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null;
    notifyInstallPromptListeners();
  });
}

export const isStandaloneDisplay = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
};

export const getAddToHomeScreenPlatform = () => {
  if (typeof navigator === 'undefined') return 'unsupported';
  const userAgent = navigator.userAgent || '';
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios';
  if (/android/i.test(userAgent)) return 'android';
  return 'unsupported';
};

export const isAddToHomeScreenDismissed = (storeId) => {
  if (!storeId || typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(dismissStorageKey(storeId)) === '1';
  } catch {
    return false;
  }
};

export const dismissAddToHomeScreen = (storeId) => {
  if (!storeId || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(dismissStorageKey(storeId), '1');
  } catch {
    // Ignore storage failures; the bar can still be hidden in memory.
  }
  notifyInstallPromptListeners();
};

export const canShowAddToHomeScreen = (scopeId, { requireStoreHost = true } = {}) => (
  Boolean(scopeId)
  && (!requireStoreHost || isSubdomainStoreMode())
  && getAddToHomeScreenPlatform() !== 'unsupported'
  && !isStandaloneDisplay()
  && !isAddToHomeScreenDismissed(scopeId)
);

export const subscribeToInstallPrompt = (listener) => {
  installPromptListeners.add(listener);
  return () => installPromptListeners.delete(listener);
};

export const getDeferredInstallPrompt = () => deferredInstallPrompt;

export const clearDeferredInstallPrompt = () => {
  deferredInstallPrompt = null;
  notifyInstallPromptListeners();
};
